export function assignWith(target: any, source: any, key?: any) {
  Object.keys(target)
    .concat(key)
    .map((x) => {
      if (source?.hasOwnProperty(x)) {
        target[x] = source[x];
      }
    });
}
//获取视频第一帧封面
export const getVideoCover = (file: File) => {
  const fileUrl = URL.createObjectURL(file);
  const videoElement = document.createElement("VIDEO") as HTMLVideoElement;
  videoElement.setAttribute("autoplay", "autoplay");
  videoElement.setAttribute("muted", "");
  videoElement.src = fileUrl;
  return new Promise<string>((resolve, rejuect) => {
    videoElement.addEventListener("loadeddata", (e) => {
      try {
        const { videoWidth, videoHeight } = videoElement; // 获取video的宽高
        const canvas = document.createElement("canvas");
        canvas.width = videoWidth;
        canvas.height = videoHeight;
        const ctx = canvas.getContext("2d") as CanvasRenderingContext2D;
        ctx.fillStyle = "#000";
        ctx.fillRect(0, 0, videoWidth, videoHeight);
        ctx.drawImage(videoElement, 0, 0, videoWidth, videoHeight);
        const src = canvas.toDataURL("image/png"); // 完成base64图片的创建
        videoElement.pause();
        resolve(src);
      } catch (error) {
        rejuect("");
      }
    });
  });
};

// 设备类型
export function deviceJudge(): string {
  if (/(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent)) {
    return "ios";
  } else if (/(Android)/i.test(navigator.userAgent)) {
    return "android";
  } else if (/(Mac)/i.test(navigator.userAgent)) {
    return "Mac";
  } else if (/(Window)/i.test(navigator.userAgent)) {
    return "Window";
  } else {
    return "unkown";
  }
}
